export function remapItemObject(item, ids) {
  const id = item.object?.objectId;
  return ids[id] == null ? item : { ...item, object: { ...item.object, objectId: ids[id] } };
}

export function requireSavedObject(item) {
  if (item.object?.objectId != null && Number(item.object.objectId) < 0) {
    throw new Error(`Az objektum még nincs elmentve (azonosító: ${item.object.objectId}).`);
  }
  return item;
}

export async function saveDraftObjects(objects, create, onSaved) {
  const ids = {};
  for (const draft of objects.filter(object => object.__isDraft || Number(object.objectId) < 0)) {
    const saved = await create({
      name: draft.name, usedScript: draft.usedScript, work: draft.work,
      client: draft.client, setting: draft.setting, usedColors: draft.usedColors,
      position: draft.position ?? '[0,0,0]', rotation: draft.rotation ?? '[0,0,0]',
      size: draft.size ?? '[0,0,0]'
    });
    if (!saved || !Number.isSafeInteger(Number(saved.objectId)) || Number(saved.objectId) <= 0) {
      throw new Error('A szerver nem adott érvényes objektumazonosítót.');
    }
    ids[draft.objectId] = saved.objectId;
    // Commit each mapping immediately so a later failure can be retried safely.
    onSaved(draft, saved);
  }
  return ids;
}
